import { makeT } from '../../../../group_leader/helpers/i18n'
import { useDispatch } from 'react-redux'
import { glApi, useEnrollInSkinsMutation, useImportMemberMutation } from '../../../../group_leader/store/glApi'
import { showErrorNotification } from '../../../../shared/helpers'

const t = makeT('group_leader.event_setup.players')

// How long the queued handicap job takes to write the indexes, after which the sheet is worth re-reading.
const HANDICAP_WRITE_DELAY_MS = 3000

// Not a failure: the golfer is in the event.
const isAlreadyEnrolled = (error) => error?.status === 422 && error?.data?.code === 'already_enrolled'

// Import the member, then enrol them in skins; callers undo their optimistic state on false.
const useEnrollGolfer = ({ leagueId, roundId }) => {
  const [ importMember, { isLoading: enrolling } ] = useImportMemberMutation()
  const [ enrollInSkins ] = useEnrollInSkinsMutation()
  const dispatch = useDispatch()

  const enrollGolfer = async ({ memberId, name }) => {
    const result = await importMember({ leagueId, roundId, memberId, silent: true })
    if (result.error) {
      if (isAlreadyEnrolled(result.error)) {
        dispatch(glApi.util.invalidateTags([ 'TeeSheet', 'MemberSearch' ]))
        return true
      }
      showErrorNotification(t('errors.add_failed', { name }))
      return false
    }
    // Skins needs the row the enrolment created in the event league, not the offered one.
    const enrolledId = result.data?.member_id
    if (enrolledId) { enrollInSkins({ leagueId, roundId, memberId: enrolledId }) }
    dispatch(glApi.util.invalidateTags([ 'TeeSheet', 'MemberSearch' ]))
    setTimeout(() => dispatch(glApi.util.invalidateTags([ 'TeeSheet' ])), HANDICAP_WRITE_DELAY_MS)
    return true
  }

  return { enrollGolfer, enrolling }
}

export default useEnrollGolfer
